import '/assets/styles/sections/footer.scss';
import config from '@wearetla/tla-essentials-tools/config';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Static Assets
import image_logo from '/assets/images/logo.svg';

export const Footer = () => {
	return (
		<footer className="section footer">
			<div className="footer-wrap wrapper">
				<div className="footer-top">
					<div className="footer-content">
						<Img
								alt={config.brandInfo?.name}
								src={image_logo}
								className="content-logo" />
							<p className="content-text">Making event management simple, scalable, and successful for organizers worldwide.</p>
					</div>
					<div className="footer-social">
						{!!config.social?.contactEmail &&
							<a className="hyperlink" href={`mailto:${config.social.contactEmail}`}>{config.social.contactEmail}</a>
						}

						<ul className="social-links">
							{!!config.social?.accounts?.instagram &&
								<li className="links-link">
									<a
										target="_blank"
										rel="noopener noreferrer"
										href={config.social.accounts.instagram}>
										<Icon name="instagram" />
									</a>
								</li>
							}
							{!!config.social?.accounts?.facebook &&
								<li className="links-link">
									<a
										target="_blank"
										rel="noopener noreferrer"
										href={config.social.accounts.facebook}>
										<Icon name="facebook" />
									</a>
								</li>
							}
							{!!config.social?.accounts?.linkedin &&
								<li className="links-link">
									<a
										target="_blank"
										rel="noopener noreferrer"
										href={config.social.accounts.linkedin}>
										<Icon name="linkedin" />
									</a>
								</li>
							}
							{!!config.social?.accounts?.x &&
								<li className="links-link">
									<a
										target="_blank"
										rel="noopener noreferrer"
										href={config.social.accounts.x}>
										<Icon name="x" />
									</a>
								</li>
							}
						</ul>
					</div>
				</div>
				<div className="footer-bottom">
					© 2026 Incy Event Technologies. All rights reserved.
				</div>
			</div>
		</footer>
	)
}

export default Footer;